import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const useAIDesignAccessManager = ({ component }) => {
  const [hasAccess, setHasAccess] = useState(false);

  const {
    // superadmin: isSuperAdminUser,
    company: { superadmin_company: isSuperAdminCompany },
  } = useSelector(state => state.auth?.user) ?? { superadmin: null, company: { superadmin_company: null } };

  const accessManager = () => {
    switch (component) {
      case "widget_role":
        if (process.env.IS_AI_DESIGN_ENABLED && isSuperAdminCompany) {
          setHasAccess(true);
        }
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    accessManager();
  }, [component, isSuperAdminCompany]);

  return hasAccess;
};

export default useAIDesignAccessManager;
